"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var List_1 = tslib_1.__importDefault(require("./List"));
var HtmlList = function (_a) {
    var _b = _a.data, data = _b === void 0 ? {} : _b, renderEmpty = _a.renderEmpty;
    var renderList = function (l, path) {
        var renderListItem = function (item, itemPath) { return (react_1["default"].createElement("li", { key: itemPath.join('.') },
            react_1["default"].createElement("span", { id: itemPath.join('.') + "-" + item.ident, dangerouslySetInnerHTML: { __html: item.content || '' } }),
            item.nestedList &&
                renderList(item.nestedList, tslib_1.__spreadArrays(itemPath, ['nestedList'])))); };
        return (react_1["default"].createElement(react_1["default"].Fragment, null, l.ordered ? (react_1["default"].createElement(List_1["default"], { key: path.length ? path.join('-') : 'main', path: path, listStyleType: l.listStyleType, markerFormat: l.markerFormat, ordered: true }, (l.items || []).map(function (item, idx) {
            return renderListItem(item, tslib_1.__spreadArrays(path, ['items', idx]));
        }))) : (react_1["default"].createElement(List_1["default"], { path: path, listStyleType: l.listStyleType, ordered: false }, (l.items || []).map(function (item, idx) {
            return renderListItem(item, tslib_1.__spreadArrays(path, ['items', idx]));
        })))));
    };
    if (!data.list && renderEmpty) {
        return react_1["default"].createElement(react_1["default"].Fragment, null, renderEmpty('htmlList'));
    }
    return (react_1["default"].createElement("div", { className: "content-widget-htmlList" }, data.list && renderList(data.list, [])));
};
exports["default"] = react_1["default"].memo(HtmlList);
